import { IRegistrationActions } from "../../action-types/registration/IRegistrationActions";
import { IRegistrationReducer } from "../../reducer-model/registration/IRegistrationReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";

const initialState: IRegistrationReducer = {
    pendingClassIds: [],
    confirmedClassIds: [],
    cancellingClassIds: [],
    myStatus: eReducerStatusBase.is_not_initialization,
    myList: [],
    error_message: "",
    chotDuLieuStatus: eReducerStatusBase.is_not_initialization,
};

const without = (arr: number[], v: number) => arr.filter(x => x !== v);
const withAdd = (arr: number[], v: number) => (arr.includes(v) ? arr : [...arr, v]);

export const registrationReducer = (
    state: IRegistrationReducer = initialState,
    action: IRegistrationActions
): IRegistrationReducer => {
    switch (action.type) {
        case "REG_REGISTER_PENDING":
            return { ...state, pendingClassIds: withAdd(state.pendingClassIds, action.payload.classId) };
        case "REG_REGISTER_CONFIRMED":
            return {
                ...state,
                pendingClassIds: without(state.pendingClassIds, action.payload.classId),
                confirmedClassIds: withAdd(state.confirmedClassIds, action.payload.classId),
            };
        case "REG_REGISTER_FAILED":
        case "REG_REGISTER_ERROR":
            return { ...state, pendingClassIds: without(state.pendingClassIds, action.payload.classId) };
        case "REG_CANCEL_START":
            return { ...state, cancellingClassIds: withAdd(state.cancellingClassIds, action.payload.classId) };
        case "REG_CANCEL_SUCCESS":
            return {
                ...state,
                cancellingClassIds: without(state.cancellingClassIds, action.payload.classId),
                confirmedClassIds: without(state.confirmedClassIds, action.payload.classId),
                // Clear pendingClassIds: nếu trước đó SignalR `RegistrationConfirmed` không reach
                // (drop) → pendingClassIds vẫn giữ classId → button stuck Spinner sau cancel.
                // Cancel đã chốt trạng thái lớp → no register pending có thể tồn tại nữa.
                pendingClassIds: without(state.pendingClassIds, action.payload.classId),
            };
        case "REG_CANCEL_ERROR":
            return { ...state, cancellingClassIds: without(state.cancellingClassIds, action.payload.classId) };
        case "REG_LOAD_MY_START":
            return { ...state, myStatus: eReducerStatusBase.is_loading, error_message: "" };
        case "REG_LOAD_MY_SUCCESS":
            return { ...state, myStatus: eReducerStatusBase.is_completed, myList: action.payload };
        case "REG_LOAD_MY_ERROR":
            return { ...state, myStatus: eReducerStatusBase.is_error, error_message: action.payload };
        case "REG_CHOT_DU_LIEU_START":
            return { ...state, chotDuLieuStatus: eReducerStatusBase.is_loading };
        case "REG_CHOT_DU_LIEU_SUCCESS":
            // Optimistic update: mark các id_lop_tc trong classIds là isChotDuLieu để UI ẩn nút Hủy
            // ngay (không đợi LOAD_MY refresh trả về). Saga vẫn dispatch LOAD_MY_START sau để
            // đồng bộ lại từ DB, đảm bảo edge case (row mới sau vài ms cũng được khoá).
            return {
                ...state,
                chotDuLieuStatus: eReducerStatusBase.is_completed,
                myList: state.myList.map(r =>
                    action.payload.classIds.includes(r.id_lop_tc)
                        ? { ...r, isChotDuLieu: true, ngayChotDuLieu: action.payload.ngayChotDuLieu }
                        : r
                ),
            };
        case "REG_CHOT_DU_LIEU_ERROR":
            return { ...state, chotDuLieuStatus: eReducerStatusBase.is_error, error_message: action.payload };
        default:
            return state;
    }
};
